export default "__VITE_ASSET__CnI3nOip__"